import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import {
  Autocomplete,
  Badge,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Select,
  Switch,
  Tooltip,
} from "@mui/material";
import { getGridDateOperators } from "@mui/x-data-grid";
import { Button, Container, Grid, Typography, Alert } from "@mui/material";
import React, { useState } from "react";
import WorkIcon from "@mui/icons-material/Work";
import "./offerManagement.scss";
import Table from "./Table";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import NewDateTimePicker from "../../components/dateTimePicker/NewDateTimePicker";
import offerTypes from "./offerTypes.js";
import { indexOf, isEmpty, isNumber } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useRef } from "react";
import JoditEditor from "jodit-react";

import Loader from "../../components/loader/Loader";
import {
  getAllOfferings,
  getAllOfferingsV3,
  getExpiringOffers,
  showLoading,
  updateOffering,
} from "../../redux/actions/offering.actions";
import {
  font,
  fontSize,
  align,
  list,
  link,
  formatBlock,
} from "suneditor/src/plugins";
import { checkCharSize } from "../../utils/Validations";
import SeoComp from "../../components/offerSeo/SeoComp";
import TotalCard from "../../components/comman/cards/TextCards.jsx";
import AnimatedButton from "../../components/comman/buttons/buttons.jsx";
import SaveIcon from "@mui/icons-material/Save";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg.jsx";
import CommonShimmer from "../../components/comman/shimmerTable/ShimmerTable.jsx";
import DialBoxContent from "../../components/comman/dialogContent/DialogBoxCon.jsx";
import { toast } from "react-hot-toast";
import DateRangeFilterInput from "./timeDate.jsx";
import CommonDataTable from "../../components/comman/comman-table/newTable.js";
import useDebounce from "../../hooks/useDebounce.js";
import ButtonCard from "./ButtonCard.jsx";
import CommonDataDialog from "./OfferingModal.jsx";
import { fetchBrands } from "../../redux/actions/brands.actions.js";
import { fetchTags } from "../../redux/actions/tags.actions.js";
import { AnimatePresence, motion } from "framer-motion";
const dateOperators = getGridDateOperators();

const betweenOperator = {
  label: "is between",
  value: "between",
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || !filterItem.value.start || !filterItem.value.end) {
      return null;
    }

    return (params) => {
      const value = params.value;
      const start = new Date(filterItem.value.start);
      const end = new Date(filterItem.value.end);
      const dateValue = new Date(value);
      return dateValue >= start && dateValue <= end;
    };
  },
  InputComponent: DateRangeFilterInput, // you’ll need a custom input component
};

const validityOperators = [...dateOperators, betweenOperator];
const { get_current_date } = require("../../utils/utilities");

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const getUserDetail = async (userId) => {
  const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
  const response = await fetch(`${host}/api/v3/source_business/${userId}`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      accessToken: localStorage.getItem("accessToken"),
    },
  }).catch((err) => { });

  const json = await response.json();

  return json[0];
};

const OfferManagement = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const { offerings, loading, expiringOffers } = useSelector(
    (state) => state.offeringReducer
  );
  console.log(expiringOffers, "expiringOffers")

  const [showExpiringOffer, setShowExpiringOffer] = useState(false);
  const { user_roleid } = user;
  const [value, setValue] = React.useState(null);
  const [openCodesPopup, setOpenCodesPopup] = useState(false);
  const [unavailableCodes, setUnavailableCodes] = useState([]);
  const [open, setOpen] = useState(false);
  const [offerT, setOfferT] = useState("");

  const [offerSubTag, setOfferSubTag] = useState([]);
  const [tag, setTag] = useState([]);
  const [subTag, setSubTag] = useState([]);
  console.log(subTag, tag, "subTagsubTag");
  const [selectedTagId, setSelectedTagId] = useState("");
  const [discountType, setDiscountType] = useState("");
  const currentDateTime = get_current_date();
  const [logo, setLogo] = useState("");
  const [icon, setIcon] = useState("");
  const [offers, setOffers] = useState([]);
  const [action, setAction] = useState("Add");
  const [offerValidity, setOfferValidity] = useState("");
  const [editedOffer, setEditedOffer] = useState([]);
  // const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [escalationPeople, setEscalationPeople] = useState([]);
  const [isSaveClick, SetIsSaveClick] = useState(false);
  const editorRef1 = useRef(null);
  const editorRef2 = useRef(null);
  const [isCopiedNew, setIsCopiedNew] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState({});
  const brands = useSelector((state) => state.brandsReducer.brands?.data) || [];
  const tags = useSelector((state) => state.tagsReducer.tags?.data) || [];
  const [offerTag, setOfferTag] = useState([]);

  useEffect(() => {
    if (tags) {
      setOfferTag(tags);
      const subTags = tags?.flatMap((tag) => tag?.subtags) || [];
      setOfferSubTag(subTags);
    }
  }, [tags]);

  const [searchValue, setSearchValue] = useState("");
  const [filteredBrands, setFilteredBrands] = useState(brands);
  /************************************* POP UP **************************************/
  const initialPValues = {
    "Brand Name": "",
    offering_id: "",
    source_business_id: "",
    discount_type: "",
    discount: "",
    details: "",
    type: "",
    tag: [],
    tnc: "",
    redemption_process: "",
    status: "",
    is_verified: "",
    is_deleted: "",
    validity: "",
    esc_person_id: "",
    verified_by: "",
    modified_by: "",
    created_by: "",
    created_at: "",
    modified_at: "",
    priority: "",
    actual_mrp: "",
    short_offer: "",
    value: "",
    redemption_url: "",
    coin: "",
  };
  const [openPopup, setOpenPopup] = useState(false);
  const [popupData, setPopupData] = useState(initialPValues);
  const [images, setImages] = useState({
    "Brand Logo": null,
    "Brand Icon": null,
  });
  const [shortOfferFlag, setShortOfferFlag] = useState(true);
  //regex for positive numbers only
  const regexPositiveNo = /^[0-9\b]+$/;
  //check number in 0-100
  function numRange(val, min, max) {
    val = parseInt(val);
    if (val >= min && val <= max) {
      return true;
    } else {
      return false;
    }
  }

  const allBrands = brands.map((option) => (
    <MenuItem key={option.brand_id} value={option.brand_id}>
      {option.brand_name}
    </MenuItem>
  ));

  const formValid = (object) => {
    let valid = true;
    for (const key in object) {
      if (key === "tag") continue;
      // if (key === "short_offer") continue;
      if (key === "tnc") continue;
      if (key === "redemption_process") continue;
      if (key === "status") continue;
      if (key === "actual_mrp" && object.discount_type != "MRP") continue;
      if (key === "special_offer" && object.type != "Special Offer") continue;

      let value = String(object[key]);
      if (!value.length) {
        valid = false;
        toast.error(`${key} cannot be empty.`);
        if (key === "short_offer") {
        }
        break;
      }
    }
    return valid;
  };

  const fetchUnavilableCodes = async () => {
    const response = await fetch(`${host}/api/v1/offerings/unavailable/codes`, {
      method: "GET" /* GET, POST, PUT, DELETE, etc. */,
      headers: {
        "Content-Type": "application/json",
        accessToken: localStorage.getItem("accessToken"),
      },
    }).catch((err) => { });

    const json = await response.json();
    setUnavailableCodes(json);
    return json;
  };

  const handleFetchUnavailableCodes = async () => {
    const codes = await fetchUnavilableCodes();
    if (codes) setOpenCodesPopup(true);
  };

  const getAllUsers = async () => {
    const response = await fetch(`${host}/api/v1/users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accessToken: localStorage.getItem("accessToken"),
      },
    }).catch((err) => {
      console.log(err.mesage);
    });

    const data = await response.json();

    setEscalationPeople(data);
  };

  const handeleEscalation = (event) => {
    event.preventDefault();
    setSelectedValue(event.target.value);
    setnewOffer({ ...newOffer, ["esc_person_id"]: event.target.value });
    setEditedOffer({ ...editedOffer, ["esc_person_id"]: event.target.value });
  };

  const [error, setError] = useState({
    brand_error: true,
    type_error: true,
    discount_error: true,
    actual_mrp: true,
    priority: true,
    short_offer: true,
    discount_type_error: true,
    details_error: true,
    tnc_error: true,
    redemption_process_error: true,
    tags_error: true,
    logo_error: true,
    icon_error: true,
    consumption_type_error: true,
    //validity_error: true,
  });
  const [alertType, setAlertType] = useState("Success");
  const [mrpCheck, setMrpCheck] = useState(false);
  const [compaignSearch, setCompaignForSearch] = useState("");
  const [page, setPage] = useState(1);
  const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
  const activeOffers = offers
    .map((item) => item?.status)
    .filter((item) => item === true);

  const discountTypes = [
    {
      id: 1,
      dType: "cash",
    },
    {
      id: 2,
      dType: "%",
    },
    {
      id: 3,
      dType: "MRP",
    },
  ];
  const [newOffer, setnewOffer] = useState({
    source_business_id: "",
    discount_type: "",
    consumption_type: "",
    discount: 0,
    actual_mrp: 0,
    special_offer: "",
    short_offer: "",
    priority: 200,
    details: "",
    type: "",
    tnc: "",
    redemption_process: "",
    redemption_url: "",
    coin: "",
    validity: offerValidity,
    esc_person_id: "",
    status: 0,
    created_by: 1,
    modified_by: 1,
    created_at: currentDateTime,
  });

  const handleClickOpen = () => {
    setOpen(true);
    // dispatch(fetchTags());
  };
  const clikShowExpiringOffer = () => {
    if (expiringOffers?.total < 1) {
      return;
    } else if (!showExpiringOffer) {
      setShowExpiringOffer(true);
      toast("Showing Expiring Offers", { icon: "ℹ️" });
    } else {
      setShowExpiringOffer(false);
    }
  };
  const handleIcon = (event) => {
    const size = event.target.files[0].size;
    if (size < 50000 && size > 0) {
      setIcon(event.target.files[0]);
      const myElement = document.getElementById("brandIcon");
      myElement.src = `${URL.createObjectURL(event.target.files[0])}`;
      error.icon_error = false;
    } else {
      error.icon_error = true;
    }
  };
  const handleLogo = (event) => {
    const size = event.target.files[0].size;
    if (size < 50000 && size > 0) {
      setLogo(event.target.files[0]);
      const myElement = document.getElementById("brandLogo");
      myElement.src = `${URL.createObjectURL(event.target.files[0])}`;
      error.logo_error = false;
    } else {
      error.logo_error = true;
    }
  };

  const clearOffer = () => {
    newOffer.tnc = "";
    newOffer.redemption_process = "";
    setnewOffer({
      source_business_id: "",
      discount_type: "",
      discount: 0,
      actual_mrp: 0,
      special_offer: "",
      short_offer: "",
      priority: 200,
      details: "",
      type: "",
      tag: "",
      tnc: "",
      redemption_process: "",
      validity: "",
      redemption_url: "",
      coin: "",
      esc_person_id: "",
      status: 0,
      created_by: "1",
      modified_by: "1",
      created_at: currentDateTime,
      is_verified: 0,
      is_deleted: 0,
      consumption_type: "",
    });
    setIcon("");
    setLogo("");
    error.logo_error = true;
    error.icon_error = true;
    setOfferSubTag([]);
    setTag([]);
  };

  const handleClose = () => {
    clearOffer();
    setOpen(false);
    setDiscountType("");
    setSelectedTagId("");
    setAction("Add");
    setBrand("");
    setSelectedValue("");
    SetIsSaveClick(false);
    setValue(null);
    setFilteredBrands(brands);
    setSearchValue("");
    setEditedOffer(null);
    setEditedOffer({});
  };

  const handleStatusChange = async (rowid, status) => {
    if (await statusUpdate(rowid, status)) {
      dispatch(getAllOfferingsV3(1, 10, "", true));
    }
  };
  const handeleOfferType = (event) => {
    if (!isEmpty(event.target.value)) {
      error.type_error = false;
      if (
        event.target.value === "Knockout Deal" ||
        event.target.value === "Special Offer"
      ) {
        newOffer.discount_type = "MRP";
        editedOffer.discount_type = "MRP";
        error.discount_type_error = false;

        setMrpCheck(true);
      } else {
        setMrpCheck(false);
      }
    }
    setOfferT(event.target.value);
    setnewOffer({ ...newOffer, ["type"]: `${event.target.value}` });
    setEditedOffer({ ...editedOffer, ["type"]: event.target.value });
  };
  const handleDiscountType = (event) => {
    if (!isEmpty(event.target.value)) {
      error.discount_type_error = false;
      setDiscountType(event.target.value);
      setnewOffer({ ...newOffer, ["discount_type"]: `${event.target.value}` });
      setEditedOffer({ ...editedOffer, ["discount_type"]: event.target.value });
    }
  };

  const handleBrandClick = (brandObj) => {
    if (!brandObj) {
      error.brand_error = false;
      setBrand("");
      setnewOffer({ ...newOffer, ["source_business_id"]: "" });
      setEditedOffer({ ...editedOffer, ["source_business_id"]: "" });
    } else {
      setBrand(brandObj.brand_id);
      setnewOffer({
        ...newOffer,
        ["source_business_id"]: `${brandObj.brand_id}`,
      });
      setEditedOffer({
        ...editedOffer,
        ["source_business_id"]: brandObj.brand_id,
      });
    }
  };
  const handleIsVerfied = (rowid, is_verified) => {
    const data = {
      is_verified,
    };
    dispatch(updateOffering(rowid, data));
  };

  const handleTag = (event) => {
    const value = event.target.value; // arr of all selected tags
    var selectTagId = value.filter((item) => !tag.includes(item));
    var deSelectTagId = tag.filter((item) => !value.includes(item));
    var tagId = selectTagId?.length > 0 ? selectTagId : deSelectTagId;

    // set subtag list according to tagId;
    var subTagList;
    var tagSelected = offerTag?.filter((item) => item?.id === tagId[0]);
    if (
      tagSelected &&
      tagSelected?.length > 0 &&
      tagSelected[0]?.subtags?.length > 0
    ) {
      subTagList = tagSelected[0]?.subtags;
    } else {
      subTagList = [];
    }

    // if subtag of deSelected tag is already selected don't deselect from tag list
    if (deSelectTagId?.length > 0) {
      //handle case3:
      if (subTagList?.some((item) => subTag?.includes(item?.id))) {
        value.push(tagId[0]);
      } else if (value?.length > 0) {
        //handle case2.0:
        tagId = value[0];
        tagSelected = offerTag?.filter((item) => item?.id === tagId);
        if (
          tagSelected &&
          tagSelected?.length > 0 &&
          tagSelected[0]?.subtags?.length > 0
        ) {
          subTagList = tagSelected[0]?.subtags;
        } else {
          subTagList = [];
        }
      } else {
        //handle case2.1
        tagId = "";
        subTagList = [];
      }
    }

    setOfferSubTag(subTagList);
    setTag(value);

    if (tagId) {
      setSelectedTagId(tagId);
    } else {
      setSelectedTagId("");
      setOfferSubTag([]);
    }
  };
  const handleSubTag = (event) => {
    let { value } = event.target;
    const normalized = Array.isArray(value)
      ? value.map(String)
      : [String(value)];

    setSubTag(normalized);
  };

  const handleDetails = async (content) => {
    try {
      const res = await fetch(
        `${host}/api/v3/offerings/${content.offering_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      );

      const json = await res.json();
      const offer = json?.data;
      if (!offer) return;

      // Set base values
      setBrand(offer.source_business_id);
      setOfferT(offer.type);
      setSelectedValue(offer.esc_person_id);
      setDiscountType(offer.discount_type);

      setImages({
        "Brand Logo": offer.logo,
        "Brand Icon": offer.icon,
      });
      setValue(content?.validity);
      // Check discount type
      if (
        offer.discount_type === "Knockout Deal" ||
        offer.discount_type === "Special Offer"
      ) {
        setMrpCheck(true);
        setnewOffer((prev) => ({ ...prev, discount_type: "MRP" }));
        setEditedOffer((prev) => ({ ...prev, discount_type: "MRP" }));
        setError((prev) => ({ ...prev, discount_type_error: false }));
      } else {
        setMrpCheck(false);
      }

      // Parse tags and subtags
      const tagVal = offer?.tag?.tags?.map((tag) => tag.id) || [];

      const tagId = tagVal.length > 0 ? [tagVal[0]] : [];

      const offersubtags = offer?.tag?.tags?.flatMap((items) => items?.subtags);

      // Deduplicate all subtags across all tags
      const allSubtagIds = [];
      offer?.tag?.tags?.forEach((tag) => {
        tag?.subtags?.forEach((sub) => {
          if (!allSubtagIds.includes(sub.id)) {
            allSubtagIds.push(sub.id);
          }
        });
      });

      // Update state
      setTag(tagVal);
      setSubTag(allSubtagIds);
      setOfferSubTag(offersubtags);
      setSelectedTagId(tagId);
      setAction("Add");
      setIsCopiedNew(true);

      setnewOffer((prev) => ({
        ...prev,
        source_business_id: offer.source_business_id,
        discount_type: offer.discount_type,
        discount: offer.discount,
        actual_mrp: offer.actual_mrp,
        special_offer: offer.special_offer,
        short_offer: offer.short_offer,
        priority: offer.priority,
        details: offer.details,
        type: offer.type,
        tnc: offer.tnc,
        redemption_process: offer.redemption_process,
        redemption_url: offer.redemption_url,
        coin: offer.coin,
        esc_person_id: offer.esc_person_id,
        status: 0,
        logo: offer?.logo,
        icon: offer?.icon,
        consumption_type: offer.consumption_type,
      }));

      setOpen(true);
    } catch (error) {
      console.error("Error updating offer:", error);
      toast.error("Something went wrong.");
    }
  };

  const updateOffer = async (id) => {
    try {
      // 🔹 Get single offer details via API
      const res = await fetch(`${host}/api/v3/offerings/${id.offering_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accessToken: localStorage.getItem("accessToken"),
        },
      });

      const json = await res.json();
      const offer = json?.data;
      setOpen(true);
      setAction("Edit");
      if (!offer) return;

      // Extract tag IDs
      const tagIds = offer?.tag?.tags?.map((t) => t?.id?.toString()) || [];
      setValue(offer?.validity);
      // Extract subtags from first selected tag and convert IDs to strings
      const selectedSubTagIds =
        offer?.tag?.tags?.flatMap(
          (t) => t?.subtags?.map((s) => s?.id?.toString()) || []
        ) || [];

      // 🔹 Build payload to update
      const payload = {
        offering_id: offer.offering_id,
        brand_name: offer.brand_name,
        source_business_id: offer.source_business_id,
        discount_type: offer.discount_type,
        discount: offer.discount,
        details: offer.details,
        type: offer.type,
        tnc: offer.tnc,
        redemption_process: offer.redemption_process,
        status: offer.status,
        is_verified: offer.is_verified,
        is_deleted: offer.is_deleted,
        validity: offer.validity,
        esc_person_id: offer.esc_person_id,
        modified_by: offer.modified_by,
        created_by: offer.created_by,
        created_at: offer.created_at,
        modified_at: new Date().toISOString(),
        priority: offer.priority,
        actual_mrp: offer.actual_mrp,
        special_offer: offer.special_offer,
        short_offer: offer.short_offer,
        value: offer.value,
        redemption_url: offer.redemption_url,
        coin: offer.coin ?? 0,
        consumption_type: offer.consumption_type,
        tag: tagIds,
        subtag: selectedSubTagIds,
        logo: offer.logo || "",
        icon: offer.icon || "",
      };
      setnewOffer(payload);
      setEditedOffer(payload);
      setBrand(offer.source_business_id);
      const data = offer.tag?.tags?.map((item) => item?.subtags)[0] || [];
      setOfferSubTag(data);
      setTag(tagIds);
      setSubTag(selectedSubTagIds);

      setImages({
        "Brand Logo": offer.logo || "",
        "Brand Icon": offer.icon || "",
      });
    } catch (error) {
      console.error("Error updating offer:", error);
      toast.error("Something went wrong.");
    }
  };

  const handleView = async (id) => {
    const response = await fetch(
      `${host}/api/v3/offerings/${id?.offering_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accessToken: localStorage.getItem("accessToken"),
        },
      }
    );
    const thisOffer = await response.json();

    if (!thisOffer) return;

    let tags = thisOffer?.data?.tag?.tags?.map((tag) => tag);

    let subTags = tags?.map((tag) => tag?.subtags)?.flatMap((subtag) => subtag);

    setPopupData({
      "Brand Name": thisOffer?.data?.brand_name || "",
      "Offering ID": thisOffer?.data?.offering_id || "",
      Type: thisOffer?.data?.type || "",
      Details: thisOffer?.data?.details || "",
      "Discount Price": thisOffer?.data?.discount_price ?? "",
      "Actual Price": thisOffer?.data?.actual_price ?? "",
      "Coin Value": thisOffer?.data?.coin ?? "",
      "Consumption Type": thisOffer?.data?.consumption_type || "",
      Validity: thisOffer?.data?.validity || "",
      Status: thisOffer?.data?.status ? "Active" : "Inactive",
      Verified: thisOffer?.data?.is_verified ? "Yes" : "No",
      "Verified By": thisOffer?.data?.esc_person?.user_name || "",
      Tags: tags.join(", "),
    });
    setImages({
      "Brand Logo": thisOffer?.data?.logo || "",
      "Brand Icon": thisOffer?.data?.icon || "",
    });
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    // setPopupData(initialPValues);
    setOpenPopup(false);
  };

  useEffect(() => {
    dispatch(getExpiringOffers());
    getAllUsers();
    dispatch(fetchBrands());
    dispatch(fetchTags());
  }, [dispatch]);

  const debouncedSearch = useDebounce(compaignSearch, 600);

  useEffect(() => {
    if (compaignSearch) {
      dispatch(getAllOfferingsV3(page, 10, debouncedSearch));
    } else {
      dispatch(getAllOfferingsV3(page, 10, debouncedSearch));
    }
  }, [dispatch, debouncedSearch, page]);

  let columns = [
    { key: "offering_id", label: "Offering ID" },
    { key: "details", label: "Details" },
    { key: "brand_name", label: "Brand Name" },
    { key: "discount_price", label: "Discount Price" },
    { key: "actual_price", label: "Actual Price" },
    { key: "type", label: "Type" },
    { key: "validity", label: "Validity" },
    { key: "coin", label: "Coin" },
    { key: "consumption_type", label: "Consumption Type" },
    { key: "status", label: "Status" },
    { key: "is_verified", label: "Is Verified" },
  ];

  if (user_roleid === 3 || user_roleid === 4 || user_roleid === 6)
    columns = columns.filter((column) => column.headerName !== "Verified");

  //Delete Offer
  const showDeleteAlert = (id) => {
    setDeleteAlert({ show: true, id: id?.offering_id });

    sessionStorage.setItem("offering", id?.offering_id);
  };

  const deleteOffer = async () => {
    setDeleteAlert({});

    const id = sessionStorage.getItem("offering");
    const response = await fetch(`${host}/api/v1/offerings/${id}`, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        accessToken: localStorage.getItem("accessToken"),
      },
    });
    //const json= await response.json();
    if (response) {
      if (response.status === 200) {
        setAlertType("success");
        sessionStorage.removeItem("id");
        toast.success("Offering is deleted successfully!");
        dispatch(getExpiringOffers());
        // dispatch(getAllOfferings());
        dispatch(getAllOfferingsV3());
        let Offer = offers.filter((e) => {
          return e.offering_id !== id;
        });
        setOffers(Offer);
      } else {
        setAlertType("error");
        sessionStorage.removeItem("id");
        toast.error("Unable to delete offering!");
      }
      //await fetchOffers();
      sessionStorage.removeItem("id");
    } else {
      setAlertType("error");
      toast.error("Unable to delete offering!");
      sessionStorage.removeItem("id");
    }
  };

  //Create Offer
  const createOffer = async (mode) => {
    //event.preventDefault();
    dispatch(showLoading(true));

    try {
      const formData = new FormData();
      if (!newOffer?.logo || !newOffer?.icon) {
        if (!logo || !icon) {
          dispatch(showLoading(false));
          setAlertType("error");
          return;
        }
        formData.append("logo", logo);
        formData.append("icon", icon);
      }
      if (action === "Add") {
        for (let key in newOffer) {
          if (key === "created_by" || key === "modified_by") {
            formData.append(key, user.user_id);
            continue;
          } else if (key === "tnc" || key === "redemption_process") {
            if (newOffer[key] == "<p><br></p>") {
              formData.append(key, "<br>");
            } else {
              formData.append(key, newOffer[key]);
            }
          } else {
            formData.append(key, newOffer[key]);
          }
        }

        let tagPayload = [];
        for (let tagData of offerTag) {
          let tagObj = {};

          let subTagArr = [];
          for (let subTagData of tagData?.subtags) {
            if (subTag?.includes(subTagData?.id)) {
              subTagArr.push(subTagData?.id);
            }
          }

          if (tag?.includes(tagData?.id)) {
            tagObj.id = tagData?.id;
            tagObj.subTags = subTagArr;
            tagPayload.push(tagObj);
          }
        }

        formData.append("tags", JSON.stringify(tagPayload));
        // for (let i = 0; i < tag.length; i++) {
        // 	formData.append("tag[]", tag[i]);
        // }

        const URL = `${process.env.REACT_APP_BASE_URL_VMS}/api/v1/offerings/`;

        await fetch(URL, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          headers: { accessToken: localStorage.getItem("accessToken") },
          body: formData,
        })
          .then(async (response) => {
            const newOffer = await response.json();
            // setOffers(offers.concat(newOffer.data));
            dispatch(showLoading(false));
            if (response.status === 200) {
              setOffers(offers.concat(newOffer.data));
              setAlertType("success");
              dispatch(getExpiringOffers());
              dispatch(getAllOfferingsV3(1, 10, "", true));
              handleClose();
              toast.success("Offering created successfully!");
              setIsCopiedNew(false);
            } else {
              setAlertType("error");
              toast.error("Unable to create offering!");
            }
          })
          .catch((err) => {
            dispatch(showLoading(false));
            setAlertType("error");
            toast.error("Unable to create offering!");
          });
      } else {
        if (editOffer()) {
          // fetchOffers();
          dispatch(getExpiringOffers());
          // dispatch(getAllOfferings());
          dispatch(getAllOfferingsV3(1, 10, "", true));
          // fetchTags();
          handleClose();
        }
      }
    } catch (error) {
      console.log(error);
      setAlertType("error");
      toast.error("Unable to create offering!");
    }
  };
  const handleTextFieldChange = (e) => {
    if (e.target.id === "details") {
      if (!checkCharSize(e.target.value, 200)) {
        return;
      }
      if (!isEmpty(e.target.value)) {
        error.details_error = false;
      } else {
        error.details_error = true;
      }
    }
    if (e.target.id === "discount") {
      if (!isEmpty(e.target.value)) {
        if (!regexPositiveNo.test(e.target.value)) {
          error.discount_error = true;
          return;
        } else if (discountType == "%" && !numRange(e.target.value, 0, 100)) {
          error.discount_error = true;
          return;
        }
        error.discount_error = false;
        error.short_offer = false;
      } else {
        error.discount_error = true;
      }
    }
    if (e.target.id === "actual_mrp") {
      if (!isEmpty(e.target.value)) {
        if (!regexPositiveNo.test(e.target.value)) {
          error.actual_mrp = true;
          return;
        }
        error.actual_mrp = false;
        //setShortOfferFlag(true)
      } else {
        error.actual_mrp = true;
      }
    }
    if (e.target.id === "priority") {
      if (e.target.value && !regexPositiveNo.test(e.target.value)) {
        return;
      }
      if (!isEmpty(e.target.value)) {
        error.priority = false;
      } else {
        error.priority = true;
      }
    }
    if (e.target.name === "consumption_type") {
      if (!isEmpty(e.target.value)) {
        error.consumption_type = false;
      } else {
        error.consumption_type = true;
      }
    }
    if (e.target.id === "coin") {
      if (e.target.value && !regexPositiveNo.test(e.target.value)) {
        return;
      }
    }
    if (e.target.id === "short_offer") {
      if (!checkCharSize(e.target.value, 40)) {
        return;
      }
      if (!isEmpty(e.target.value)) {
        error.short_offer = false;
        setShortOfferFlag(false);
      } else {
        error.short_offer = true;
      }
    }
    if (e.target.id === "redemption_url") {
      if (!isEmpty(e.target.value)) {
        error.discount_error = false;
      } else {
        error.discount_error = true;
      }
    }
    if (e.target.id === "tnc") {
      if (!isEmpty(e.target.value)) {
        error.tnc_error = false;
      } else {
        error.tnc_error = true;
      }
    }
    if (e.target.id === "redemption_process") {
      if (!isEmpty(e.target.value)) {
        error.redemption_process_error = false;
      } else {
        error.redemption_process_error = true;
      }
    }
    if (e.target.id === "special_offer" && !checkCharSize(e.target.value, 40)) {
      return;
    }
    if (e.target.name === "consumption_type") {
      setnewOffer({ ...newOffer, [e.target.name]: e.target.value });
      setEditedOffer({ ...editedOffer, [e.target.name]: e.target.value });
    } else {
      setnewOffer({ ...newOffer, [e.target.id]: e.target.value });
      setEditedOffer({ ...editedOffer, [e.target.id]: e.target.value });
    }
  };

  const statusUpdate = async (offering_id, status) => {
    const data = { status };
    const response = await fetch(`${host}/api/v3/offerings/${offering_id}`, {
      method: "PATCH", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        accessToken: localStorage.getItem("accessToken"),
      },
      body: JSON.stringify(data),
    });
    const json = await response.json();
    toast.success("Status updated successfully!");
    if (json) {
      return 1;
    }
  };

  //update Api For Offer
  const editOffer = async () => {
    delete editedOffer["is_verified"];
    delete editedOffer["is_deleted"];

    const formData = new FormData();

    // Remove logo/icon if they exist in editedOffer to avoid duplication
    delete editedOffer["logo"];
    delete editedOffer["icon"];
    delete editedOffer["tags"];
    delete editedOffer["validity"];
    delete editedOffer["brand_name"];
    delete editedOffer["subtag"];
    delete editedOffer["modified_bys"];

    // Append logo and icon first
    formData.append("logo", logo);
    formData.append("icon", icon);

    for (var key in editedOffer) {
      if (key === "discount" || key === "actual_mrp") {
        if (!editedOffer[key]) {
          setAlertType("error");
          toast.error("Please enter valid " + key);
          return 0;
        } else {
          formData.append(key, editedOffer[key]);
        }
      } else if (key === "tnc" || key === "redemption_process") {
        formData.append(
          key,
          editedOffer[key] === "<p><br></p>" ? "<br>" : editedOffer[key]
        );
      } else {
        formData.append(key, editedOffer[key]);
      }
    }

    // Handle tags
    let tagPayload = [];
    for (let tagData of offerTag) {
      let subTagArr = [];
      for (let subTagData of tagData?.subtags) {
        if (subTag?.includes(subTagData?.id)) {
          subTagArr.push(subTagData?.id);
        }
      }

      if (tag?.includes(tagData?.id)) {
        tagPayload.push({ id: tagData?.id, subTags: subTagArr });
      }
    }
    formData.append("tags", JSON.stringify(tagPayload));

    // Handle validity
    if (value?.$d) {
      const dateTime = value.$d;
      const date = `${dateTime.getFullYear()}-${dateTime.getMonth() + 1
        }-${dateTime.getDate()}`;
      const time = `${dateTime.getHours()}:${dateTime.getMinutes()}:00`;
      formData.append("validity", `${date} ${time}`);
    }

    // modified_by is already added in editedOffer, skip adding modified_bys
    // Clean-up safety
    formData.delete("modified_bys");

    const response = await fetch(
      `${host}/api/v1/offerings/${newOffer.offering_id}`,
      {
        method: "PATCH",
        headers: { accessToken: localStorage.getItem("accessToken") },
        body: formData,
      }
    );

    const json = await response.json();
    dispatch(showLoading(false));

    if (json.msg) {
      setAlertType("error");
      toast.error(json.msg);
      return 0;
    } else if (json.data !== "") {
      dispatch(getExpiringOffers());
      dispatch(getAllOfferingsV3(1, 10, "", true));
      setAlertType("success");
      toast.success("Offering updated successfully!");
      handleClose();
      return 1;
    }
  };

  function handleSpecial_offer(value) {
    if (value) {
      error.tnc_error = false;
    }
    // if ( !checkCharSize(value, 47)) {
    // 	return
    // }
    const key = "special_offer";
    setnewOffer((newOffer) => ({ ...newOffer, [key]: value }));
    setEditedOffer((editedOffer) => ({ ...editedOffer, [key]: value }));
  }

  function handleTnc(value) {
    if (value) {
      error.tnc_error = false;
    }
    setnewOffer((newOffer) => ({ ...newOffer, ["tnc"]: value }));
    setEditedOffer((editedOffer) => ({ ...editedOffer, ["tnc"]: value }));
  }
  function handleRedemtionProcess(value) {
    if (value) {
      error.redemption_process_error = false;
    }
    setnewOffer((newOffer) => ({ ...newOffer, ["redemption_process"]: value }));
    setEditedOffer((editedOffer) => ({
      ...editedOffer,
      ["redemption_process"]: value,
    }));
  }

  const handlePageChange = async (page) => {
    setPage(page);
  };

  const buttons = [
    {
      label: "Create Offer",
      icon: <AddIcon />,
      onClick: handleClickOpen,
    },
    {
      label: "Offering Codes",
      icon: <AddIcon />,
      onClick: handleFetchUnavailableCodes,
    },
  ];

  const badgeElement = (
    <Tooltip
      title={
        showExpiringOffer
          ? "Showing all offers"
          : "Showing offers expiring soon"
      }
      arrow
      placement="top"
    >
      <motion.div
        onClick={clikShowExpiringOffer}
        className="cursor-pointer rounded-full p-2 transition-all duration-300 relative"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        style={{
          background: showExpiringOffer
            ? 'linear-gradient(135deg, #f0f4ff, #e6e9ff)'
            : 'linear-gradient(135deg, #fdf6f0, #fff2e6)',
          boxShadow: showExpiringOffer
            ? '0 4px 12px rgba(116, 105, 241, 0.2)'
            : '0 4px 12px rgba(255, 152, 0, 0.2)',
          border: showExpiringOffer
            ? '1px solid #d9d6ff'
            : '1px solid #ffe0b2'
        }}
      >
        <Badge
          badgeContent={
            <AnimatePresence mode="wait" initial={false}>
              <motion.span
                key={expiringOffers?.total || 0}
                initial={{ scale: 0.6, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.6, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="text-white text-xs font-bold"
                style={{
                  background: "transparent",

                  minWidth: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {expiringOffers?.total || 0}
              </motion.span>
            </AnimatePresence>
          }
          showZero
          color="secondary"
          invisible={showExpiringOffer}
          sx={{
            '& .MuiBadge-badge': {
              right: showExpiringOffer ? -5 : -3,
              top: showExpiringOffer ? 5 : 3,
              border: showExpiringOffer
                ? '2px solid #f0f4ff'
                : '2px solid #fdf6f0',
              height: showExpiringOffer ? '20px' : '22px',
              minWidth: showExpiringOffer ? '20px' : '22px',
              borderRadius: '12px'
            }
          }}
        >
          <AnimatePresence mode="wait" initial={false}>
            {showExpiringOffer ? (
              // Count badge (shows only when "all offers")
              <motion.div
                key="count"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                className="flex items-center justify-center rounded-full w-10 h-10"
                style={{
                  background: 'linear-gradient(135deg, #7469f1, #5a4ff1)',
                  boxShadow: '0 4px 8px rgba(116, 105, 241, 0.3)'
                }}
              >
                <span className="text-white font-semibold text-sm">
                  {expiringOffers?.total || 0}
                </span>
              </motion.div>
            ) : (
              // Bell icon (shows only when "expiring offers")
              <motion.div
                key="icon"
                initial={{ rotate: -20, scale: 0.8, opacity: 0 }}
                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ type: "spring", stiffness: 200, damping: 12 }}
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
                className="flex items-center justify-center rounded-full w-10 h-10"
                style={{
                  background: 'linear-gradient(135deg, #ff9800, #f57c00)',
                  boxShadow: '0 4px 8px rgba(255, 152, 0, 0.3)'
                }}
              >
                <NotificationsActiveIcon
                  sx={{ color: "white", fontSize: 22 }}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </Badge>

        {/* Subtle pulsing animation for attention */}
        {!showExpiringOffer && expiringOffers?.total > 0 && (
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'linear-gradient(135deg, #ff9800, #f57c00)',
              zIndex: -1
            }}
            initial={{ opacity: 0.5, scale: 1 }}
            animate={{ opacity: 0, scale: 1.5 }}
            transition={{
              repeat: Infinity,
              repeatType: "reverse",
              duration: 1.5
            }}
          />
        )}
      </motion.div>
    </Tooltip>
  );
  const getFilteredDiscountTypes = () => {
    switch (offerT) {
      case "Cash Voucher":
        return discountTypes.filter(
          (d) => d.dType === "cash" || d.dType === "%"
        );
      case "Special Offer":
        return discountTypes.filter(
          (d) => d.dType === "MRP" || d.dType === "%"
        );
      case "Knockout Deal":
        return discountTypes.filter((d) => d.dType === "MRP");
      default:
        return discountTypes;
    }
  };

  useEffect(() => {
    if (offerT === "Special Offer") {
      setnewOffer((prev) => ({
        ...prev,
        coin: "0",
      }));
    } else if (offerT === "Cash Voucher") {
      setnewOffer((prev) => ({
        ...prev,
        coin: "",
      }));
    }
  }, [offerT]);

  const columnsCode = [
    { key: "id", header: "ID" },
    { key: "available", header: "Available" },
  ];


  const filteredData = offerings?.result?.filter((offer) =>
    expiringOffers?.offerings?.some((expired) => expired?.offering_id === offer?.offering_id)
  );

const config = {
  readonly: false,
  height: 400,
  toolbarButtonSize: "middle",
  buttons: [
    "bold",
    "underline",
    "italic",
    "|",
    "link",
    "|",
    "font",
    "fontsize",
    "brush",
    "|",
    "align",
    "ul",
    "ol",
    "|",
    "fullsize",
    "source",
  ],
  defaultFont: "Inter",
  defaultFontSize: 16,
  enableDragAndDrop: false,
  spellcheck: true,

  // Paste-related
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  processPasteHTML: true,
  processPasteFromWord: true,
  allowPaste: true,
  disablePlugins: ["pasteStorage"],

  // 👇 Fix spacing issues
  enter: "p", // don't wrap in <p>
  useSplitMode: false,
  beautifyHTML: false,
  cleanHTML: {
    timeout: 0,
    replaceNBSP: true,
    fillEmptyParagraph: false,
  },
};



  return (
    <Container className="offer-management ">
      <Grid container direction="column" spacing={5}>
        <Grid item>
          <motion.div
            className="offer-management-intro"
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
          >
            <h2>Offer Management Overview</h2>
            <p>
              Track total and active offers, then manage records with quick
              actions from one place.
            </p>
          </motion.div>
        </Grid>
        <Grid
          container
          item
          direction="row"
          justifyContent=""
          gap={2}
        >
          <TotalCard
            text={`Total OFFERS: ${offerings?.totalCount || 0}`}
            icons={<WorkIcon fontSize="medium" repeat={0} />}
            color={"#7469f1"}
            width={"350px"}
          />
          <TotalCard
            text={`ACTIVE OFFERS: ${offerings?.totalActive || 0}`}
            icons={<WorkIcon fontSize="medium" repeat={0} />}
            color={"#7469f1"}
            width={"350px"}
          />
        </Grid>
        <Grid item>

          {(user_roleid === 1 || user_roleid === 2 || user_roleid === 3) && (
            <ButtonCard
              buttons={buttons}
              rightElement={badgeElement}
              heading="Offer Actions"
            />
          )}

          <div className="offer-table-scroll-wrap mt-10">
            <div style={{ width: "100%", height: "100%" }}>
              <CommonDataTable
                data={showExpiringOffer ? filteredData : offerings?.result}
                onView={handleView}
                onEdit={updateOffer}
                onDelete={showDeleteAlert}
                onToggleStatus={handleStatusChange}
                onToggleVerified={handleIsVerfied}
                currentPage={page}
                expiredData={expiringOffers?.offerings || []}
                onPageChange={(newPage) => handlePageChange(newPage)}
                showSearch={true}
                totalPages={offerings?.totalPages}
                setCompaignForSearch={setCompaignForSearch}
                compaignSearch={compaignSearch}
                columns={columns}
                searchText="Search By Offering Id And Brand Name..."
                copyPrevData={handleDetails}
                showExpiringOffer={showExpiringOffer}
                enableHorizontalScroll={(columns?.length || 0) > 12}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
          fullWidth
          maxWidth="xl"
          scroll="paper"
          PaperProps={{
            sx: {
              borderRadius: 3,
              overflow: "hidden",
              maxHeight: "92vh",
              border: "1px solid transparent",
              background:
                "linear-gradient(155deg, rgba(8, 17, 36, 0.96) 0%, rgba(18, 32, 62, 0.9) 100%) padding-box, linear-gradient(125deg, rgba(56, 189, 248, 0.85) 0%, rgba(59, 130, 246, 0.85) 45%, rgba(99, 102, 241, 0.85) 100%) border-box",
            },
          }}
          BackdropProps={{
            sx: {
              backdropFilter: "blur(6px)",
              backgroundColor: "rgba(2, 6, 23, 0.6)",
            },
          }}
        >
          <AppBar
            sx={{
              position: "relative",
              background:
                "linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
            }}
          >
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => {
                  handleClose();
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Offering
              </Typography>
              {
                <AnimatedButton
                  label={`${action === "Add" ? "Save Offer" : "Update Offer"}`}
                  icon={<SaveIcon />}
                  onClick={() => {
                    if (action === "Edit") return editOffer();

                    const valid = formValid(newOffer);
                    if (!valid) return SetIsSaveClick(true);
                    createOffer();
                  }}
                  sx={{
                    background:
                      "linear-gradient(45deg, #ffffff 30%, #ffffff 90%)",
                    color: "black",
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                    },
                  }}
                  disabled={loading}
                />
              }
            </Toolbar>
          </AppBar>
          <DialogContent
            dividers
            sx={{
              p: 0,
              overflowX: "hidden",
              overflowY: "auto",
              maxHeight: "calc(92vh - 64px)",
            }}
          >
            {loading ? (
              action == "Add" ? (
                <Loader status={"Creating"} />
              ) : (
                <Loader status={"Updating"} />
              )
            ) : (
              <>
                <Grid
                  id="dilogbox"
                  sx={{
                    "& .MuiTextField-root": { m: 2, ml: 5, width: "65ch" },
                    "& label": {
                      color: "rgba(255,255,255,0.88)",
                    },
                    "& .MuiInputLabel-root": {
                      color: "rgba(255,255,255,0.88)",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#ffffff",
                    },
                    "& .MuiInputBase-input": {
                      color: "#ffffff",
                    },
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "rgba(255,255,255,0.06)",
                      borderRadius: "10px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(255,255,255,0.35)",
                    },
                    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(255,255,255,0.55)",
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#67e8f9",
                      borderWidth: "2px",
                    },
                    "& .MuiFormHelperText-root": {
                      color: "rgba(255,255,255,0.85) !important",
                    },
                    "& .MuiSelect-icon": {
                      color: "#ffffff",
                    },
                  }}
                  container
                  direction="row"
                >
                <Grid id="grid1" container item xs={12} sm={12} md={6}>
                  <Autocomplete
                    error={isSaveClick && !brand.length ? true : false}
                    defaultValue={() => {
                      if (isCopiedNew) {
                        let arr = brands.filter((obj) => obj.brand_id == brand);
                        return arr[0];
                      } else if (action == "Add") {
                        return;
                      } else if (action == "Edit") {
                        let arr = brands.filter((obj) => obj.brand_id == brand);
                        return arr[0];
                      }
                    }}
                    id="combo-box"
                    sx={{ m: 0, ml: 0, p: 0, width: "auto" }}
                    options={brands}
                    getOptionLabel={(option) => option.brand_name}
                    renderInput={(params) => (
                      <TextField {...params} label="Brands" />
                    )}
                    onChange={(e, value, reason) => {
                      handleBrandClick(value);
                    }}
                  />
                  <TextField
                    required
                    id="details"
                    label="Offer details"
                    placeholder={"Eg. Flat 20% off on xyz"}
                    multiline
                    maxRows={4}
                    value={newOffer.details}
                    onChange={handleTextFieldChange}
                    error={
                      isSaveClick && !newOffer.details.length ? true : false
                    }
                    helperText={
                      !newOffer.details
                        ? "200 char left"
                        : `${200 - parseInt(newOffer.details.length)} char left`
                    }
                  />
                  <TextField
                    required
                    id="type"
                    select
                    label="Offer Types"
                    placeholder="Offer Types"
                    value={offerT || newOffer.type}
                    onChange={(e) => {
                      newOffer.discount = "";
                      newOffer.actual_mrp = "";
                      handeleOfferType(e);
                    }}
                    error={isSaveClick && !offerT.length ? true : false}
                  >
                    {offerTypes.map((option) => (
                      <MenuItem key={option.id} value={option.type}>
                        {option.type}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    required
                    id="discountType"
                    select
                    label="Discount Types"
                    placeholder="Discount Type"
                    value={discountType || newOffer.discount_type}
                    onChange={(e) => {
                      newOffer.discount = "";
                      newOffer.actual_mrp = "";
                      handleDiscountType(e);
                    }}
                    error={isSaveClick && !discountType?.length}
                  >
                    {getFilteredDiscountTypes().map((option) => (
                      <MenuItem key={option.id} value={option.dType}>
                        {option.dType}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    required
                    id="discount"
                    label={mrpCheck ? "Discount Price" : "Discount Price"}
                    placeholder={mrpCheck ? "Discount Price" : "Discount Price"}
                    value={newOffer.discount}
                    onChange={handleTextFieldChange}
                    error={isSaveClick && !newOffer.discount ? true : false}
                  />
                  <TextField
                    required
                    id="actual_mrp"
                    label="Actual MRP"
                    placeholder="Actual MRP"
                    value={newOffer.actual_mrp}
                    // disabled={ mrpCheck ? false : true }
                    onChange={handleTextFieldChange}
                    error={
                      isSaveClick && !newOffer.actual_mrp?.length ? true : false
                    }
                  />

                  <div
                    style={{
                      marginLeft: "40px",
                      marginBottom: "10px",
                      width: "65ch",
                    }}
                  >
                    <label>Pay only shipping/T&C Apply/MRP</label>
                    {/* <SunEditor ref={ editorRef1 } onChange={ handleTnc } setContents={ newOffer.tnc } /> */}
                    <SunEditor
                      ref={editorRef1}
                      onChange={handleSpecial_offer}
                      placeholder="T&C Apply"
                      setContents={newOffer.special_offer}
                      disable={mrpCheck ? false : true}
                      //   setDefaultStyle="font-family: Inter; font-size: 16px;"
                      error={
                        isSaveClick && !newOffer.special_offer?.length
                          ? true
                          : false
                      }
                      setOptions={{
                        buttonList: [["strike"]],
                        plugins: [formatBlock],
                      }}
                    />
                    <label>
                      {!newOffer.special_offer
                        ? "40 char left"
                        : `${47 - parseInt(newOffer.special_offer.length)
                        } char left`}
                    </label>
                  </div>
                  <TextField
                    required
                    id="short_offer"
                    label="Short Offer"
                    placeholder="Short Offer"
                    value={newOffer.short_offer}
                    error={
                      isSaveClick && !newOffer.short_offer?.length
                        ? true
                        : false
                    }
                    onChange={handleTextFieldChange}
                    helperText={
                      !newOffer.short_offer
                        ? "40 char left"
                        : `${40 - parseInt(newOffer.short_offer.length)
                        } char left`
                    }
                  />
                  <TextField
                    required
                    id="priority"
                    label="Priority"
                    placeholder="Priority"
                    value={newOffer.priority}
                    onChange={handleTextFieldChange}
                    error={isSaveClick && !newOffer.priority ? true : false}
                  />
                </Grid>
                <Grid id="grid2" item xs={12} sm={12} md={6}>
                  <TextField
                    required
                    id="esc_person_id"
                    select
                    label="Escalation Person"
                    placeholder="Escalation Person"
                    onChange={handeleEscalation}
                    value={selectedValue || newOffer.esc_person_id}
                    error={isSaveClick && !selectedValue?.length ? true : false}
                  >
                    {escalationPeople.map((option) => {
                      return (
                        <MenuItem key={option.user_id} value={option.user_id}>
                          {option.user_name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <div
                    style={{
                      marginLeft: "40px",
                      marginBottom: "10px",
                      width: "65ch",
                    }}
                  >
                    <label>T&C</label>

                    {/* <JoditEditor
                      ref={editorRef1}
                      value={newOffer.tnc}
                      config={config}
                      onBlur={(newContent) => handleTnc(newContent)} // trigger on content change
                    /> */}

                    <SunEditor ref={ editorRef1 } onChange={ (newContent) => handleTnc(newContent) } setContents={ newOffer.tnc } 
                        setDefaultStyle="font-family: Inter; font-size: 16px;"
                      setOptions={{
                        buttonList: [
                          ["bold", "underline", "italic"],
                          ["link"],
                          ["font", "fontSize", "formatBlock"],
                          ["align", "list"],
                          ["fullScreen", "codeView"],
                        ],
                        plugins: [
                          font,
                          fontSize,
                          align,
                          list,
                          link,
                          formatBlock,
                        ],
                        font: [
                          "Inter",
                          "Arial",
                          "Calibri",
                          "Comic Sans",
                          "Georgia",
                          "Impact",
                          "Tahoma",
                          "Times New Roman",
                        ],
                      }}
                      />
                  </div>
                  <div
                    style={{
                      marginLeft: "40px",
                      marginBottom: "10px",
                      width: "65ch",
                    }}
                  >
                    <label>Redemption-Process</label>
                    {/* <SunEditor ref={ editorRef2 } onChange={ handleRedemtionProcess } setContents={ newOffer.redemption_process } /> */}
                    <SunEditor
                      ref={editorRef1}
                      onChange={handleRedemtionProcess}
                      setContents={newOffer.redemption_process}
                      setDefaultStyle="font-family: Inter; font-size: 16px;"
                      setOptions={{
                        buttonList: [
                          ["bold", "underline", "italic"],
                          ["link"],
                          ["font", "fontSize", "formatBlock"],
                          ["align", "list"],
                          ["fullScreen", "codeView"],
                        ],
                        plugins: [
                          font,
                          fontSize,
                          align,
                          list,
                          link,
                          formatBlock,
                        ],
                        font: [
                          "Inter",
                          "Arial",
                          "Calibri",
                          "Comic Sans",
                          "Georgia",
                          "Impact",
                          "Tahoma",
                          "Times New Roman",
                        ],
                      }}
                    />
                  </div>
                  <TextField
                    required
                    id="coin"
                    label="Coin value"
                    maxRows={4}
                    placeholder="Please enter coin worth for unlocking this offering"
                    value={newOffer.coin}
                    onChange={handleTextFieldChange}
                    error={isSaveClick && !newOffer.coin?.length ? true : false}
                  />
                  <TextField
                    required
                    select
                    id="consumption_type"
                    label="Consumption Type"
                    placeholder="Please Select Consumption Type"
                    value={newOffer.consumption_type}
                    onChange={handleTextFieldChange}
                    name="consumption_type"
                    error={isSaveClick && !newOffer.consumption_type?.length}
                  >
                    <MenuItem value="Generic">Generic</MenuItem>
                    <MenuItem value="Dynamic">Dynamic</MenuItem>
                  </TextField>

                  <TextField
                    required
                    id="redemption_url"
                    label="Redemption URL"
                    maxRows={4}
                    placeholder="Redemption URL"
                    value={newOffer.redemption_url}
                    onChange={handleTextFieldChange}
                    error={
                      isSaveClick && !newOffer.redemption_url?.length
                        ? true
                        : false
                    }
                  />
                  <div>
                    <NewDateTimePicker
                      required
                      value={value}
                      setValue={setValue}
                      newOffer={newOffer}
                      setnewOffer={setnewOffer}
                    />
                  </div>
                  <FormControl
                    sx={{
                      ml: 5,
                      mt: 2,
                      mb: 2,
                      width: "65ch",
                    }}
                  >
                    <InputLabel id="mutiple-select-label">Tags</InputLabel>
                    <Select
                      required
                      multiple
                      labelId="mutiple-select-label"
                      label="Tags"
                      name="tag"
                      value={tag}
                      onChange={handleTag}
                      renderValue={(tags) => {
                        let arr = [];
                        (Array.isArray(tags) ? tags : []).forEach((id) => {
                          (Array.isArray(offerTag) ? offerTag : []).forEach(
                            (offer) => {
                              if (offer?.id == id) {
                                arr.push(offer?.name);
                              }
                            }
                          );
                        });
                        return arr.join(", ");
                      }}
                    >
                      {(Array.isArray(offerTag) ? offerTag : []).map(
                        (option) => (
                          <MenuItem key={option.id} value={option.id}>
                            <ListItemIcon>
                              <Checkbox checked={tag.indexOf(option.id) > -1} />
                            </ListItemIcon>
                            <ListItemText primary={option.name} />
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                  <FormControl
                    sx={{
                      ml: 5,
                      mt: 2,
                      mb: 2,
                      width: "65ch",
                    }}
                  >
                    <InputLabel id="mutiple-select-label">Subtags</InputLabel>
                    <Select
                      required
                      multiple
                      labelId="mutiple-select-label"
                      label="Subtags"
                      name="subtags"
                      value={subTag}
                      onChange={handleSubTag}
                      renderValue={(subTags) => {
                        let arr = [];
                        subTags?.map((id) => {
                          offerSubTag?.map((item) => {
                            if (item.id == id) {
                              arr.push(item.name);
                            }
                          });
                        });
                        return arr.join(", ");
                      }}
                      MenuProps={MenuProps}
                    >
                      {offerSubTag.map((option) => (
                        <MenuItem key={option.id} value={option.id?.toString()}>
                          <ListItemIcon>
                            <Checkbox
                              checked={subTag
                                ?.map(String)
                                .includes(String(option.id))}
                            />
                          </ListItemIcon>
                          <ListItemText primary={option.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Stack direction="row" spacing={2} marginLeft={5}>
                    <Item>
                      <img
                        id="brandLogo"
                        src={`${newOffer.logo}`}
                        alt="Brand logo"
                        width="50"
                        height="50"
                      />
                    </Item>
                    <Item>
                      <img
                        id="brandIcon"
                        src={`${newOffer.icon}`}
                        alt="Brand Icon"
                        width="50"
                        height="50"
                      />
                    </Item>
                  </Stack>
                  <Stack
                    direction="row"
                    spacing={2}
                    marginLeft={5}
                    marginTop={5}
                    marginRight={6}
                  >
                    {error.logo_error && (
                      <Alert icon={false} variant="warning">
                        Logo size must be less than 50KB
                      </Alert>
                    )}
                    <Item>
                      <Button variant="contained" component="label">
                        Upload Logo
                        <input hidden onChange={handleLogo} type="file" />
                      </Button>
                    </Item>
                    {error.icon_error && (
                      <Alert icon={false} variant="warning">
                        {" "}
                        Icon size must be less than 50KB
                      </Alert>
                    )}
                    <Item>
                      <Button variant="contained" component="label">
                        Upload Icon
                        <input hidden onChange={handleIcon} type="file" />
                      </Button>
                    </Item>
                    {action === "Edit" && (
                      <Item>
                        {editedOffer?.offering_id ? (
                          <SeoComp offering_id={editedOffer?.offering_id} />
                        ) : (
                          <SeoComp offering_id={newOffer?.offering_id} />
                        )}
                      </Item>
                    )}
                  </Stack>
                  <div></div>
                </Grid>
                </Grid>
              </>
            )}
          </DialogContent>
        </Dialog>
      </div>
      {/***********************  Detailed Source business popup ************************/}

      <DialBoxContent
        open={openPopup}
        handleClose={handleClosePopup}
        title={popupData["Brand Name"]}
        heading="Offer Details"
        subHeading={`Complete information for ${
          popupData["Brand Name"] || "selected offer"
        }`}
        images={images}
        data={popupData}
      />

      <CommonDataDialog
        open={openCodesPopup}
        onClose={() => setOpenCodesPopup(false)}
        title="Available Codes"
        columns={columnsCode}
        rows={unavailableCodes}
        rowsPerPage={10}
      />
      {deleteAlert?.show && (
        <MessageDialog
          open={deleteAlert}
          onClose={() => setDeleteAlert(false)}
          title="Are you sure want to delete this Offer?"
          message={`Are you sure you want to delete offer id ${deleteAlert?.id}?`}
          okText={`Delete`}
          variant={"error"}
          img={`https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1748122267846-assets_task_01jw2360pqec98vpmf1vxzjzrm_1748122215_img_2.webp`}
          onConfirm={deleteOffer}
        />
      )}
    </Container>
  );
};

export default OfferManagement;
